module.exports = __webpack_public_path__ + "static/media/important-alert.c7a34bfe.svg";